export function addComma(value: string) {
	const head = value.substring(0, value.length - 2)
	const tail = value.substring(value.length - 2, value.length)

	return `${head},${tail}`
}

export const currencyFormatter = new Intl.NumberFormat('it-IT', {
	style: 'decimal',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
	useGrouping: true, // forza sempre il separatore delle migliaia
})

export function replaceDotWithComma(value: number | string | undefined) {
	if (!value) return

	const stringValue = value.toString()

	if (stringValue.includes('.')) {
		return stringValue.replace('.', ',')
	}

	return stringValue
}
export function roundAndReplace(value: number) {
	return value.toFixed(3).slice(0, -1).toString().replace('.', ',')
}
const _currencyWithSymbol = new Intl.NumberFormat('it-IT', {
	style: 'currency',
	currency: 'EUR',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
	useGrouping: true,
})


const _currencyWithNoSymbol = new Intl.NumberFormat('it-IT', {
	style: 'decimal',
	currency: 'EUR',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
	useGrouping: true,
})

export const formatCurrency = (value?: number): string => {
	if (typeof value !== 'number') return '—'
	return _currencyWithSymbol.format(value)
}


export const formatCurrencyNoValuta = (value?: number): string => {
	if (typeof value !== 'number') return '—'
	return _currencyWithNoSymbol.format(value)
}